import { Alert, Button, DatePicker, Form, Input } from "antd";
import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { doCreateAccount } from "./client";
import Password from "antd/es/input/Password";
import { getURL } from "./client";

const CreateAccountForm = (props) => {
  if (props.loggedIn) window.location.href = "/";
  const [form] = Form.useForm();
  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const app_code = queryParameters.get("application-code");
    const email = queryParameters.get("email");
    if (app_code && email) {
      form.setFieldsValue({
        "application-code": app_code,
        email: email,
      });
    }
  });
  const [hasRegistrationError, setHasRegistrationError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 16,
      },
    },
  };
  const onFinish = (values) => {
    window.scrollTo(0, 0);
    setConfirmationMessage(
      "A verification email has been sent to " + values.email
    );
    setErrorMessage("");
    setHasRegistrationError(false);
    props.setSpin(true);
    doCreateAccount(values)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 0) {
          setHasRegistrationError(true);
          setErrorMessage(data.message);
        } else {
          setIsRegistered(true);
        }
      })
      .finally((func) => {
        props.setSpin(false);
      });
  };
  const config = {
    rules: [
      {
        type: "object",
        required: true,
        message: "Please select date of birth!",
      },
    ],
  };
  return (
    <>
      <SiteHeader headerType="create-account" />
      {!isRegistered && (
        <>
          <div
            style={{ textAlign: "center", maxWidth: "350px", margin: "0 auto" }}
          >
            <h3>Create a New Account</h3>
          </div>
          <Form
            className="create-account-form"
            onFinish={onFinish}
            {...formItemLayout}
            form={form}
          >
            <Form.Item
              hasFeedback
              name="first-name"
              label="First Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="Enter First Name" />
            </Form.Item>
            <Form.Item
              hasFeedback
              name="last-name"
              label="Last Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="Enter Last Name" />
            </Form.Item>
            <Form.Item
              hasFeedback
              name="birth-date"
              label="Date of Birth"
              {...config}
            >
              <DatePicker
                placeholder="Enter Date of Birth (MM/DD/YYYY)"
                format="MM/DD/YYYY"
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
            <Form.Item
              hasFeedback
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
              ]}
            >
              <Input placeholder="Enter Email Address" />
            </Form.Item>
            <Form.Item
              hasFeedback
              name="confirm-email"
              label="Confirm Email"
              dependencies={["email"]}
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("email") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("The two emails that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input placeholder="Re-Enter Email Address" />
            </Form.Item>
            <Form.Item
              hasFeedback
              name="phone"
              label="Phone Number"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="Enter Phone Number" />
            </Form.Item>
            <Form.Item
              hasFeedback
              autoComplete="off"
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
                {
                  min: 8,
                  message: "Password length must be at least 8 characters",
                },
              ]}
            >
              <Password autoComplete="off" />
            </Form.Item>

            <Form.Item
              hasFeedback
              autoComplete="off"
              name="confirm-password"
              label="Confirm Password"
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Password autoComplete="off" />
            </Form.Item>
            {hasRegistrationError && (
              <>
                <Alert
                  message={errorMessage}
                  description=""
                  showIcon
                  type="error"
                  closable
                />
                <br />
              </>
            )}
            <Button
              block
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Register Account
            </Button>
            <p>
              <Link to={getURL("/")}>Already have an account? Sign In</Link>
            </p>
          </Form>
        </>
      )}
      {isRegistered && (
        <div className="sign-in-intro">
          <Alert
            message={confirmationMessage}
            description="Please check your email and verify your account."
            type="success"
          />
        </div>
      )}
      <SiteFooter />
    </>
  );
};
export default CreateAccountForm;
